import React, { useContext, useEffect, useState } from 'react'
import {
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import classes from '../pages/destinations/destinations.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faMinusCircle } from '@fortawesome/pro-light-svg-icons'
import DividerSvg from '../svg/Divider.svg'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { AccordionActions } from '@material-ui/core'
import {
  calculateMarkup,
  formatAmountForDisplay,
} from '../../utils/stripe-helpers'
import ApiContext from '../../utils/api-context'
import { CurrencyContext } from '../../lib/context/CurrencyContext'
import { SettingsContext } from '../../lib/context/SettingsContext'
import moment from 'moment'
import { SearchContext } from '../../lib/context/search-context'
import PlusCircle from '../svg/PlusCircle.svg'
import { faUser } from '@fortawesome/pro-solid-svg-icons'

const RetreatRoom = ({
  room,
  fromDate,
  fromPrice,
  accordionIndex,
  selectedRoom,
  updateSelectedRoom,
}) => {
  const { apiUrl, cdnUrl } = useContext(ApiContext)
  const { currency } = useContext(CurrencyContext)
  const { settings } = useContext(SettingsContext)
  const [roomPrice, setRoomPrice] = useState(0)
  const { searchParams, setSearchParameters } = useContext(SearchContext)
  const [numGuests, setNumGuests] = useState(1)
  const [numRooms, setNumRooms] = useState(1)
  const [roomDate, setRoomDate] = useState(null)

  useEffect(() => {
    setRoomPrice(room.rates[0].adults + room.rates[0].children)
    if (room.datesSelectable) {
      setRoomDate(room.rates[0].startDate)
    } else {
      setRoomDate(searchParams.checkinDate)
    }
  }, [])
  useEffect(() => {
    if (!room.datesSelectable) {
      setRoomDate(searchParams.checkinDate)
    }
    updateSelectedRoom(null, true)
  }, [searchParams])
  return (
    <AccordionItem
      uuid={`option${accordionIndex + 1}`}
      className={classes.roomAccordionItem}
    >
      <AccordionItemHeading
        className={`${classes.roomAccordionHeading} ${
          selectedRoom &&
          selectedRoom.filter((r) => r.id === room.id).length === 1
            ? classes.roomAccordionHeadingSelected
            : ''
        }`}
      >
        <AccordionItemButton
          className={`accordion__button ${classes.roomAccordionButton}`}
        >
          <h2>{room.name}</h2>
          <FontAwesomeIcon icon={faChevronDown} />
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <div className={classes.availabilityCard}>
          {room.gallery.length > 0 && (
            <div className={classes.packageFeatureImage}>
              <img src={`${room.gallery[0].url}`} alt="" />
            </div>
          )}

          <div className={classes.availabilityInner}>
            <div className={classes.availabilityContent}>
              <div className={classes.availabilityInfo}>
                <h2
                  className={classes.availabilityHeader}
                  style={{ paddingTop: 0 }}
                >
                  {room.name}
                </h2>
                {room.description !== '' && (
                  <div
                    // className={classes.availabilityReadmore}
                    dangerouslySetInnerHTML={{
                      __html: room.description,
                    }}
                  />
                )}
              </div>
              {room.features.length > 0 && (
                <>
                  <DividerSvg />
                  <div
                    className={`${classes.availabilityCosts} ${classes.glance}`}
                  >
                    <div>
                      <h4>At a glance</h4>
                      <ul>
                        {room.features.map((feature, j) => {
                          return (
                            <li key={j}>
                              <FontAwesomeIcon
                                icon={faCheckCircle}
                                size={'2x'}
                              />
                              {feature.text}
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  </div>
                </>
              )}
            </div>

            {room.occupancy && room.occupancy > 0 && (
              <p className="sleeps text-blue px-[40px]">
                <strong>Sleeps:</strong>{' '}
                {Array.from(Array(room.occupancy), (e, i) => {
                  return (
                    <React.Fragment key={i}>
                      <FontAwesomeIcon icon={faUser} />{' '}
                    </React.Fragment>
                  )
                })}
              </p>
            )}
          </div>
        </div>
      </AccordionItemPanel>
      <AccordionActions>
        <div className={classes.roomAccordionTotal}>
          <p className={classes.roomAccordionTotalLabel}>
            Retreat Total:{' '}
            <span className={classes.roomAccordionTotalPrice}>
              {formatAmountForDisplay(
                calculateMarkup(
                  roomPrice + fromPrice,
                  settings.baseMarkup,
                  null
                ),
                currency,
                settings.exchangeRate
              )}
            </span>{' '}
            {room.perPerson && (
              <span className={classes.roomAccordionPerPerson}>/ person</span>
            )}
          </p>
          <div className="flex-grow flex flex-col gap-4 lg:flex-row items-center justify-end w-full lg:w-auto">
            {room.rates && room.rates.length > 0 && room.datesSelectable && (
              <select
                className={'selectable-dates'}
                defaultValue={
                  roomDate && moment.isMoment(roomDate)
                    ? roomDate.format('YYYY-MM-DD')
                    : ''
                }
                onChange={(evt) => {
                  if (evt.currentTarget.value != '') {
                    setRoomDate(moment(evt.currentTarget.value))
                  } else {
                    setRoomDate(null)
                  }
                }}
              >
                <option value="">Select Date</option>
                {room.rates.map((rate, i) => {
                  return (
                    <option key={i} value={rate.startDate}>
                      {moment(rate.startDate).format('ddd Do MMMM, YYYY')}
                    </option>
                  )
                })}
              </select>
            )}
            <div className={`${classes.guestsWrapper} mr-0 lg:mr-8 `}>
              <div
                className={classes.guests}
                // onClick={() => setGuestsPopup(true)}
              >
                <span
                  className={numRooms <= 1 ? 'guests-disabled' : ''}
                  onClick={() => {
                    if (numRooms <= 1) {
                      if (
                        selectedRoom.length > 0 &&
                        selectedRoom.filter((r) => r.id === room.id).length ===
                          1
                      ) {
                        updateSelectedRoom({
                          ...room,
                          guests: numGuests,
                          price: roomPrice + fromPrice,
                          checkin: roomDate.checkin,
                          checkout: roomDate.checkout,
                          individual: !!(
                            room.perPerson !== null && room.perPerson
                          ),
                          quantity: 1,
                        })
                      }
                      setNumRooms(1)
                    } else {
                      if (
                        selectedRoom.length > 0 &&
                        selectedRoom.filter((r) => r.id === room.id).length ===
                          1
                      ) {
                        updateSelectedRoom({
                          ...room,
                          guests: numGuests,
                          price: roomPrice + fromPrice,
                          checkin: roomDate.checkin,
                          checkout: roomDate.checkout,
                          individual: !!(
                            room.perPerson !== null && room.perPerson
                          ),
                          quantity: numRooms - 1,
                        })
                      }
                      setNumRooms(numRooms - 1)
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faMinusCircle} />
                </span>
                <span>
                {numRooms} Guest{numRooms !== 1 ? 's' : ''}
                </span>
                <span
                  onClick={() => {
                    if (
                      selectedRoom.length > 0 &&
                      selectedRoom.filter((r) => r.id === room.id).length === 1
                    ) {
                      updateSelectedRoom({
                        ...room,
                        guests: numGuests,
                        price: roomPrice + fromPrice,
                        checkin: roomDate,
                        individual: !!(
                          room.perPerson !== null && room.perPerson
                        ),
                        quantity: numRooms + 1,
                      })
                    }
                    setNumRooms(numRooms + 1)
                  }}
                >
                  <PlusCircle />
                </span>
              </div>
            </div>
            <button
              className={`${classes.roomAccordionAddToBasket} ${
                selectedRoom &&
                selectedRoom.filter((r) => r.id === room.id).length === 1
                  ? classes.selectedButton
                  : classes.selectButton
              }`}
              onClick={() => {
                if (
                  selectedRoom &&
                  selectedRoom.filter((r) => r.id === room.id).length === 1
                ) {
                  updateSelectedRoom(room, true)
                } else {
                  if (roomDate)
                    updateSelectedRoom({
                      ...room,
                      guests: room.occupancy ? room.occupancy : numGuests,
                      price: roomPrice + fromPrice,
                      checkin: roomDate,
                      individual: !!(room.perPerson !== null && room.perPerson),
                      quantity: numRooms,
                    })
                }
              }}
            >
              {selectedRoom &&
              selectedRoom.filter((r) => r.id === room.id).length === 1
                ? 'Selected'
                : 'Select'}
            </button>
          </div>
        </div>
      </AccordionActions>
    </AccordionItem>
  )
}
export default RetreatRoom
